<div>
    @if (plan?.data?.from_abroad) {
        <div class="column mb-1">
            <p class="icon-and-text is-aligned-center">
                <span class="icon is-small is-secondary">
                    <i class="tri-at-globe"></i>
                </span>
                <span class="text is-level-2 is-marginless text-uppercase" [innerHTML]="plan.data.from_abroad"></span>
            </p>
        </div>
    }
    @if (plan?.data?.unlimited_call) {
        <div class="column mb-1">
            <p class="icon-and-text is-aligned-center">
                <span class="icon is-small is-secondary">
                    <i class="tri-shooting-star"></i>
                </span>
                <span class="text is-level-2 is-marginless" [innerHTML]="plan.data.unlimited_call"></span>
            </p>
        </div>
    }
    @if (plan?.data?.double_sim) {
        <div class="column mb-1">
            <p class="icon-and-text is-aligned-center">
                <span class="icon is-small is-secondary">
                    <i class="tri-sim-cards"></i>
                </span>
                @if (!isDarwin) {
                    <span class="text is-level-2 is-marginless">
                        Une 2ème carte SIM Internet pour utiliser votre forfait sur un second appareil (tablette,
                        montre...)
                    </span>
                }
                @if (isDarwin) {
                    <span class="text is-level-2 is-marginless">
                        Tous les 6 mois, un nouveau palier, avec appels illimités et plus de gigas (10Go puis 20Go) en
                        France métropolitaine
                    </span>
                }
            </p>
        </div>
    }
    @if (plan?.data?.sms_mms) {
        <div class="column mb-1">
            <p class="icon-and-text is-aligned-center">
                <span class="icon is-small is-secondary">
                    <i class="tri-phone-waiting-call"></i>
                </span>
                <span class="text is-level-2 is-marginless" [innerHTML]="plan.data.sms_mms"></span>
            </p>
        </div>
    }
    @if (plan.data.international_call) {
        <div class="column mb-1">
            <p class="icon-and-text is-aligned-center">
                <span class="icon is-small is-secondary">
                    <i class="tri-phone-outgoing-call"></i>
                </span>
                <span
                    (textWithLink)="toggleInternationalCall(true)"
                    [innerHTML]="plan.data.international_call | trustHtml"
                    class="text is-level-2 is-marginless"
                ></span>
            </p>
        </div>
    }
    <div class="column mb-1">
        <p class="icon-and-text is-aligned-center">
            <span class="icon is-small is-secondary">
                <i class="tri-hand-mobile"></i>
            </span>
            <span class="text is-level-2 is-marginless">Assistance 24h/24 via l'application</span>
        </p>
    </div>
</div>
@if (showInternationalCallsList) {
    <div class="columns is-multiline is-marginless has-background-grey-fade">
        <div class="column is-fullwidth is-narrow has-text-right">
            <span class="icon" (click)="toggleInternationalCall(false)">
                <i class="tri-times" aria-hidden="true"></i>
            </span>
        </div>
        <div class="column mb-1">
            <checkout-cms-block [blockId]="internationalCallsCmsBlockId" [battlefront]="false"></checkout-cms-block>
        </div>
    </div>
}
